// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1819":"9740a344","2282":"9740a344","4015":"9740a344","7351":"9740a344"}[chunkId] + ".chunk.css";
};